// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-field[data-v-e81129a4]{display:flex;padding:8px 16px;border-bottom:1px solid rgba(0,0,0,.06)}.preview-field[data-v-e81129a4]:last-child{border-bottom:none}.preview-field .field-label[data-v-e81129a4]{font-weight:500;min-width:200px;flex-shrink:0}.preview-field .field-value[data-v-e81129a4]{flex-grow:1}.theme--dark .preview-field[data-v-e81129a4]{border-bottom-color:rgba(255,255,255,.12)}", ""]);
// Exports
module.exports = exports;
